import { patch } from "@src/appV2/api";
import { environmentConfig } from "@src/appV2/environment";
import { logEvent } from "@src/appV2/lib/analytics";
import {
  type PendVisitRequest,
  pendVisitRequestSchema,
  visitResponseSchema,
  type VisitWithCaseData,
} from "@src/appV2/redesign/InHome/types";
import { getVisitQueryKey } from "@src/appV2/redesign/InHome/useGetVisitData";
import { getVisitsQueryKey } from "@src/appV2/redesign/InHome/useGetVisitsWithCaseData";
import { useMutation, type UseMutationOptions, useQueryClient } from "@tanstack/react-query";

import { IN_HOME_USER_EVENTS } from "../lib/events";

function getPendVisitUrl(visitId: string) {
  return `${environmentConfig.REACT_APP_HOME_HEALTH_API_URL}/v1/visits/${visitId}`;
}

export function usePendVisit(
  visitId: string,
  options: UseMutationOptions<VisitWithCaseData, string, PendVisitRequest> = {}
) {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: async (params) => {
      const response = await patch({
        url: getPendVisitUrl(visitId),
        data: params,
        requestSchema: pendVisitRequestSchema,
        responseSchema: visitResponseSchema,
      });
      return response.data.data;
    },
    onSuccess: (visit) => {
      logEvent(IN_HOME_USER_EVENTS.VISIT_PENDED, {
        caseId: visit.attributes.caseId,
        visitId: visit.id,
        workerReq: visit.attributes.workerReq,
        type: visit.attributes.type,
        pendingVisitReason: visit.attributes.pendingVisitReason,
      });
      void queryClient.invalidateQueries(getVisitQueryKey(visit.id, visit.attributes.caseId));
      void queryClient.invalidateQueries(getVisitsQueryKey);
    },
    ...options,
  });
}
